import { SafePipe } from './directives/safe.pipe';
import { AgmCoreModule } from '@agm/core';
import { AgmMarkerClustererModule } from '@agm/markerclusterer';
import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgxsModule, NoopNgxsExecutionStrategy } from '@ngxs/store';
import { HighchartsChartModule } from 'highcharts-angular';
import { NgImageSliderModule } from 'ng-image-slider';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { ToastrModule } from 'ngx-toastr';
import { environment } from '../../environments/environment';
import { BuildingsMapComponent } from '../modules/buildings-map/buildings-map.component';
import { BuildingsComponent } from '../modules/buildings/buildings.component';
import { ExportImportBuildingsComponent } from '../modules/export-import-buildings/export-import-buildings.component';
import { ManageBuildingComponent } from '../modules/manage-building/manage-building.component';
import { CountryState } from '../shared/ngxs/state/country.state';
import { DonutChartComponent } from '../shared/widgets/donut-chart/donut-chart.component';
import { BuildingPreviewComponent } from './../modules/building-preview/building-preview.component';
import { BuildingsSimpleComponent } from './components/buildings-simple/buildings-simple.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { InstructionsComponent } from './components/instructions/instructions.component';
import { LogInComponent } from './components/log-in/log-in.component';
import { RegisterComponent } from './components/register/register.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { WelcomeAboardComponent } from './components/welcome-aboard/welcome-aboard.component';
import { TwoDigitDecimaNumberDirective } from './directives/two-digit-decimal.directive';
import { MaterialModule } from './material.module';
import { AccountState } from './ngxs/state/account.state';
import { BuildingState } from './ngxs/state/building.state';
import { DashboardState } from './ngxs/state/dashboard.state';
import { UserState } from './ngxs/state/management.state';
import { MunicipalityState } from './ngxs/state/municipality.state';
import { PeriodState } from './ngxs/state/period.state';
import { AuthGuardService } from './services/auth-guard.service';
import { AuthService } from './services/auth.service';
import { BuildingCategoryService } from './services/building-category.service';
import { BuildingService } from './services/building.service';
import { ConversionService } from './services/conversion.service';
import { CountryService } from './services/country.service';
import { DashboardService } from './services/dashboard.service';
import { FilterService } from './services/filter.service';
import { JwtHelperService } from './services/jwt-helper.service';
import { LocalCacheService } from './services/local-cache.service';
import { ManageBuildingHelperService } from './services/manage-building-helper.service';
import { MunicipalityService } from './services/municipality.service';
import { NotificationService } from './services/notification.service';
import { PeriodService } from './services/period.service';
import { UserService } from './services/user.service';
import { LineChartComponent } from './widgets/line-chart/line-chart.component';
import { PieChartComponent } from './widgets/pie-chart/pie-chart.component';
import { NgxsResetPluginModule } from 'ngxs-reset-plugin';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    ConfirmationDialogComponent,
    LogInComponent,
    LineChartComponent,
    BuildingPreviewComponent,
    PieChartComponent,
    BuildingsMapComponent,
    ExportImportBuildingsComponent,
    ChangePasswordComponent,
    RegisterComponent,
    BuildingsComponent,
    BuildingsSimpleComponent,
    SpinnerComponent,
    ManageBuildingComponent,
    TwoDigitDecimaNumberDirective,
    DonutChartComponent,
    InstructionsComponent,
    WelcomeAboardComponent,
    SafePipe,
  ],
  imports: [
    CommonModule,
    RouterModule,
    HighchartsChartModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MaterialModule,
    MatAutocompleteModule,
    TranslateModule,
    NgxsModule.forRoot(
      [
        AccountState,
        BuildingState,
        PeriodState,
        MunicipalityState,
        UserState,
        DashboardState,
        CountryState,
      ],
      {
        developmentMode: !environment.production,
        executionStrategy: NoopNgxsExecutionStrategy,
      }
    ),

    NgxsResetPluginModule.forRoot(),

    NgImageSliderModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAkJaKe1gHhewXDrSuGmYKJcYTlBWAoZmU',
    }),
    AgmMarkerClustererModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    GooglePlaceModule,
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    MaterialModule,
    LineChartComponent,
    PieChartComponent,
    TranslateModule,
    BuildingsMapComponent,
    BuildingsComponent,
    BuildingsSimpleComponent,
    SpinnerComponent,
    ManageBuildingComponent,
    DonutChartComponent,
    InstructionsComponent,
    WelcomeAboardComponent,
    SafePipe,
  ],
  providers: [
    DecimalPipe,
    BuildingService,
    MunicipalityService,
    PeriodService,
    UserService,
    DashboardService,
    NotificationService,
    ConversionService,
    JwtHelperService,
    AuthService,
    AuthGuardService,
    CountryService,
    FilterService,
    ManageBuildingHelperService,
    BuildingCategoryService,
    LocalCacheService,
    SafePipe,
  ],
  entryComponents: [
    ConfirmationDialogComponent,
    ExportImportBuildingsComponent,
    LogInComponent,
    ChangePasswordComponent,
    RegisterComponent,
    ManageBuildingComponent,
    InstructionsComponent,
    WelcomeAboardComponent,
  ],
})
export class SharedModule {}
